"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOrder = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const generate_session_id_1 = require("@jsmdg/generate-session-id");
const enums_1 = require("../enums");
const pushToDataLayer_1 = require("./pushToDataLayer");
const getPaymentMethodTrackingValue = (order) => {
    const { paymentType, isExpressPayment } = order.payment;
    switch (paymentType) {
        case enums_1.PaymentMethod.Invoice:
            return 'invoice';
        case enums_1.PaymentMethod.ValueVoucher:
            return 'valueVoucher';
        case enums_1.PaymentMethod.StripeCreditCard:
            return 'creditCard';
        case enums_1.PaymentMethod.StripeKlarna:
            return 'stripeKlarna';
        case enums_1.PaymentMethod.StripeGooglePay:
            return isExpressPayment ? 'googlePay' : 'GooglePayRegular';
        case enums_1.PaymentMethod.StripeApplePay:
            return isExpressPayment ? 'applePay' : 'ApplePayRegular';
        case enums_1.PaymentMethod.PayPal:
            return isExpressPayment
                ? 'Paypal Express'
                : 'paypal';
        case enums_1.PaymentMethod.AmazonPay:
            return isExpressPayment
                ? 'amazonPay'
                : 'AmazonPayRegular';
        default:
            return `ERROR! paymentMethod=${paymentType} express=${String(isExpressPayment)}`;
    }
};
const getVoucherCoverage = (paymentVouchers, voucherType) => {
    return paymentVouchers
        .filter(voucher => voucher.type === voucherType)
        .reduce((coverageAccumulator, currentValueVoucher) => coverageAccumulator + currentValueVoucher.deductedAtPurchase.amount, 0);
};
function trackOrder(order) {
    const discount = order.discount ?? order.items?.find(item => item.discount)?.discount;
    const valueVoucherCoverage = getVoucherCoverage(order.paymentVouchers, 'value_voucher');
    const multiPurposeVoucherCoverage = getVoucherCoverage(order.paymentVouchers, 'experience');
    const paymentVoucherCoverage = order.paymentVouchers.reduce((coverageAccumulator, currentValueVoucher) => coverageAccumulator + currentValueVoucher.deductedAtPurchase.amount, 0);
    const shippingCost = order.shipping?.price?.gross?.amount ?? 0;
    const merchandizeTotalGrossPrice = order.total.gross.amount - shippingCost;
    const session = js_cookie_1.default.get(generate_session_id_1.TRACKING_SESSION_ID_COOKIE_CONFIG.name);
    const giftWraps = (order.items ?? []).filter(item => item.packaging?.type === 'gift_box');
    const giftWrapTrackingText = giftWraps.length > 0
        ? giftWraps
            .flatMap(item => Array.from({ length: item.quantity }).fill(item.packaging.title))
            .join('_')
        : 'none';
    const giftWrapPrice = giftWraps.reduce((priceAccumulator, giftWrap) => priceAccumulator + giftWrap.quantity * giftWrap.packaging?.price?.gross?.amount, 0);
    (0, pushToDataLayer_1.pushToDataLayer)({
        Order: {
            id: order.orderId,
            couponcode: discount?.coupon?.code,
            currency: order.total.gross.currencyCode,
            customerEmail: order.email.toLowerCase(),
            discount: discount?.campaign,
            discountActive: discount ? 'yes' : 'no',
            merchandizeTotalGrossPrice,
            merchandizeTotalNetPrice: undefined,
            merchandizeTotalTax: undefined,
            session,
            statement: '',
            subscribeNewsletter: false,
            totalPrice: order.total.gross.amount,
            voucher: paymentVoucherCoverage > 0 ? 'yes' : 'no',
        },
        valueVoucherCoverage,
        multiPurposeVoucherCoverage,
        giftWrap: giftWrapTrackingText,
        giftWrapPrice,
        paymentMethod: getPaymentMethodTrackingValue(order),
    });
}
exports.trackOrder = trackOrder;
//# sourceMappingURL=trackOrder.js.map